@if (isOverlayOpen) { 
   <div class="backdrop"></div>
   <div class="overlay" role="dialog" aria-modal="true">
    <div class="overlay-header straightline-overlay">
        <div>
            @if(!isExternal){
            <h4>{{ 'I18N_LABEL.GENERAL_RATE_PROVISIONS' | translate }}</h4>
            }@else{
            <h4>General Rate Provisions</h4>
            }
        </div>
        <div class="close-button">
            <up-icon name="close" (click)="closeOverlay()"></up-icon>
        </div>
    </div> 
    @if (provisionsList.length > 0) { 
        <div class="overlay-content"> 
            @for (listItem of provisionsList; track listItem) { 
            <div>
            <div class="heading-padding">
                <strong>{{ listItem.name }}</strong>
            </div> 
            @for (item of listItem.list; track item) { 
                <div class="provision-container">
                    <div class="dynamic-page-backend" [innerHTML]="item.provisionData"></div>
                </div>
            }
        </div> 
    } </div> 
    } @else { 
    <div class="overlay-content">
        <p class="move-right"> {{ 'I18N_LABEL.NO_DATA_AVAILABLE' | translate }} </p>
    </div> 
  }
  <div class="button-row">
    <up-button button-style="contained">
      <button type="submit" (click)="closeOverlay()">Ok</button>
    </up-button>
  </div>
  </div> 
}